import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { IModal } from '@models/modal.model';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatDialogModule]
})
export class ModalComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IModal,
    private dialogRef: MatDialogRef<ModalComponent>,
    private router: Router
  ) { }

  public async openLiveChatPayment(): Promise<void> {
    await this.router.navigate(['/ayuda']);
    this.dialogRef.close();
  }

  public closeModal(status: boolean): void {
    this.dialogRef.close(status);
  }
}
